module.exports = __webpack_public_path__ + "static/img/female-bg-fr.50f75f1b.png";